import React from 'react';
import { AccordionItem } from './Accordion';
import { CORE_TOOLS } from '../data/content';
import { ExtraBonuses } from './ExtraBonuses';
import { Reviews } from './Reviews';
export function Bonuses() {
  return <section className="py-8" data-id="element-26" data-mp="au1v6pqlckjy">
      <div className="px-5 text-center" data-id="element-27" data-mp="autfv5ingxvg">
        <p className="text-sm font-700 uppercase tracking-widest text-[var(--pb-lime)]" data-id="element-28" data-mp="ftwi6i78wpzq">
          The Core System
        </p>
        <h2 className="mt-2 font-display text-3xl font-800 uppercase leading-tight text-white" data-id="element-29" data-mp="1tbzdm1byu68">
          6 Tools That Run Your Coaching Week
        </h2>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-white/80" data-id="element-30" data-mp="3o1lemphj5hie">
          Open each tool to see what is already built for you.
        </p>
      </div>

      <div className="mx-auto mt-6 max-w-xl space-y-3 px-5" data-id="element-31" data-mp="3t0yafzqdpyx4">
        {CORE_TOOLS.map((tool, index) => <AccordionItem key={tool.title} emoji={tool.emoji} title={`${index + 1}. ${tool.title}`} badge={tool.format} previewImage={tool.image} defaultOpen={index === 0} data-id="element-32" data-mp="1m85m1n1vtsks" data-mpi={index}>
            <p className="text-sm leading-relaxed text-white/90" data-id="element-33" data-mp="3dg4vcmgurkfg">{tool.body}</p>
          </AccordionItem>)}
      </div>

      <Reviews data-id="element-34" data-mp="3r68gtb7wra3u" />
      <ExtraBonuses data-id="element-35" data-mp="3r8ujoxjut1fq" />
    </section>;
}